export default function(instance) {
  return {
    /* PRODUCTS */
    getProducts(data) {
      return instance.get("/api/market/products/admin/", { params: data });
    },
    createProduct(data) {
      return instance.post("/api/market/products/admin/", {
        name: data.name,
        description: data.description,
        price: data.price,
        weight: data.weight
      });
    },
    getProduct(idProduct) {
      return instance.get(`/api/market/products/admin/${idProduct}/`);
    },
    updateProduct(idProduct, data) {
      return instance.put(`/api/market/products/admin/${idProduct}/`, {
        name: data.name,
        description: data.description,
        price: data.price,
        weight: data.weight
      });
    },
    updateImageProduct(idProduct, data) {
      let formData = new FormData();
      formData.append("image", data.imageFile);

      return instance.put(
        `/api/market/products/admin/${idProduct}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
    },
    deleteProduct(idProduct) {
      return instance.delete(`/api/market/products/admin/${idProduct}/`);
    },

    /* CATEGORIES */
    getCategories(data) {
      return instance.get("/api/market/categories/admin/", { params: data });
    },
    createCategory(data) {
      return instance.post("/api/market/categories/admin/", {
        name: data.name
      });
    },
    getCategory(idCategory) {
      return instance.get(`/api/market/categories/admin/${idCategory}/`);
    },
    updateCategory(idCategory, data) {
      return instance.put(`/api/market/categories/admin/${idCategory}/`, {
        name: data.name
      });
    },
    deleteCategory(idCategory) {
      return instance.delete(`/api/market/categories/admin/${idCategory}/`);
    },

    getSubCategories(data) {
      return instance.get("/api/market/subcategories/admin/", { params: data });
    },
    createSubCategory(data) {
      return instance.post("/api/market/subcategories/admin/", {
        name: data.name,
        category: data.category
      });
    },
    getSubCategory(idSubCategory) {
      return instance.get(`/api/market/subcategories/admin/${idSubCategory}/`);
    },
    updateSubCategory(idSubCategory, data) {
      return instance.put(`/api/market/subcategories/admin/${idSubCategory}/`, {
        name: data.name,
        category: data.category
      });
    },
    deleteSubCategory(idSubCategory) {
      return instance.delete(
        `/api/market/subcategories/admin/${idSubCategory}/`
      );
    },

    /* ORDERS */
    getOrders(data) {
      return instance.get("/api/market/orders/admin/", { params: data });
    },
    getOrder(idOrder) {
      return instance.get(`/api/market/orders/admin/${idOrder}/`);
    },
    updateOrder(idOrder, data) {
      return instance.put(`/api/market/orders/admin/${idOrder}/`, {
        is_delivered: data.is_delivered,
        price: data.price,
        comment: data.comment
      });
    },
    updateOrderStatus(idOrder) {
      return instance.put(`/api/market/orders/admin/${idOrder}/`, {
        is_delivered: true
      });
    },
    deleteOrder(idOrder) {
      return instance.delete(`/api/market/orders/admin/${idOrder}/`);
    }
  };
}
